import { authMiddleware } from './auth-middleware'
import { conductorMiddleware } from './conductor-middleware'
import { handleErrorMiddleware } from './handle-error-middleware'

export default [handleErrorMiddleware, conductorMiddleware, authMiddleware]
